var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var PageCase = require('../PageCase/PageCase.js');
var Header = require('../Header/Header');
var Footer = require('../Footer/Footer');
var { Spinner } = require('@metro-ui/core');

class LoginPrefsLoading extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localeId: this.props.localeId
        };
    }

    renderContent() {
        return (
            <div className="signedOutPage container">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-2"></div>
                    <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                        <div className="signedOutContainer text-center">
                            <br />
                            <Spinner
                                label="Please wait while we login you.."
                                size={2}
                            />
                            <div className="whiteContainer darkblue-text">
                                <div className="font20bold">
                                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.msg_opening'])}
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-2"></div>
                </div>
            </div>
        )
    }

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    }

    renderFooter() {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange}/>
                </div>
            </IntlProvider>
        );
    }

    render() {
        return (
            <div>
                <PageCase
                    isLoginPreferencesView={true}
                    header={<Header />}
                    content={this.renderContent()}
                    footer={this.renderFooter()}>
                </PageCase>
            </div>
        )
    }
}

module.exports = injectIntl(LoginPrefsLoading)